export const searchClose = () => {
	document.documentElement.classList.add("hide-search-box");
};
